(function () {
  function syncInfiniteOption(nativeSelect) {
    const value = nativeSelect.value;
    const optionName = nativeSelect.name.match(/\[(.+)\]/)?.[1];
    if (!optionName) return;

    const infiniteOption = document.querySelector(`select[name="properties[${optionName}]"]`);
    if (!infiniteOption) return;

    infiniteOption.value = value;
    infiniteOption.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init() {
    document.querySelectorAll('select.variant-option__select').forEach(function (select) {
      // Sync on page load
      syncInfiniteOption(select);

      // Sync on change
      select.addEventListener('change', function () {
        syncInfiniteOption(select);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();